import type { Place } from "../data/schema";

interface PlacesApiResponse {
  places: Place[];
  source: "d1" | "static-fallback";
  count?: number;
  message?: string;
}

export async function fetchRemotePlaces() {
  const response = await fetch("/api/places", {
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Places API unavailable: ${response.status}`);
  }

  const payload = (await response.json()) as PlacesApiResponse;

  if (!Array.isArray(payload.places) || payload.places.length === 0) {
    throw new Error(payload.message || "Places API returned no places");
  }

  return payload;
}
